import React from 'react';
import { observer } from 'mobx-react';
import VirtualizedTable from '../common/VirtualizedTable';

export default observer(props => {
  const columns = [
    { key: 'description', label: 'Material', width: 300 },
    { key: 'costAsStringWithDimensions', label: 'Cost', width: 250 },
  ]
  return <VirtualizedTable 
    columns={columns}
    {...props}
  />
})


// WEBPACK FOOTER //
// ./src/components/materials/MaterialTable.js